import { PropsWithChildren } from "react";
import {
  Button,
  Col,
  Col1,
  Icon,
  IconName,
  MarginProps,
  Spinner,
  TextBody,
  TextTitle,
} from "../lib";
import { TextColor } from "../theme";

type CalloutVariant = "default" | "online" | "offline";

type Props = MarginProps &
  PropsWithChildren<{
    action?: string;
    disabled?: boolean;
    icon?: IconName;
    loading?: boolean;
    message: string;
    onPress?: () => void;
    small?: boolean;
    title?: string;
    variant?: CalloutVariant;
  }>;

const variantToTextColor: Record<CalloutVariant, TextColor> = {
  default: "onSurface",
  online: "online",
  offline: "offline",
};

export function Callout({
  action,
  disabled = false,
  icon,
  loading = false,
  children,
  message,
  onPress,
  small = false,
  title,
  variant = "default",
  ...rest
}: Props) {
  const Container = small ? Col : Col1;

  return (
    <Container.C px="6" py="8" {...rest}>
      {!!icon && (
        <Col mb="4">
          <Icon
            name={icon}
            large={!small}
            color={variantToTextColor[variant]}
          />
        </Col>
      )}
      {!!title && <TextTitle center>{title}</TextTitle>}
      {message.split("|").map((line, i) => (
        <TextBody center key={line} mt="2">
          {line}
        </TextBody>
      ))}
      {loading && !action && !onPress && (
        <Col.C mt="6">
          <Spinner />
        </Col.C>
      )}

      {children}

      {!!onPress && !!action && (
        <Col mt="6">
          <Button
            em
            compact
            onPress={onPress}
            loading={loading}
            disabled={disabled}
          >
            {action}
          </Button>
        </Col>
      )}
    </Container.C>
  );
}
